export default __webpack_public_path__ + "static/media/brushteeth.60e895ff.mp3";